import { render, staticRenderFns } from "./RouteDetailPage.vue?vue&type=template&id=468fe5b3&scoped=true"
import script from "./RouteDetailPage.vue?vue&type=script&lang=js"
export * from "./RouteDetailPage.vue?vue&type=script&lang=js"
import style0 from "./RouteDetailPage.vue?vue&type=style&index=0&id=468fe5b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468fe5b3",
  null
  
)

export default component.exports